import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';

const TokenServiceFactory = function tokenServiceFactory($q, $log, Environment, StorageService, MerchantTypes, $rootScope, Dispatcher) {
    "ngInject";
    const PROFILE_MODE = {
      "CONSUMER": 0,
      "MERCHANT": 1
    };

    let
      userContext = "",
      merchantType = "",
      instrumentList = "",
      counterList = "",
      profiloDefault = StorageService.getLocalStorage("profiloDefault"),
      switchModeProfile = StorageService.getLocalStorage("profileMode") === "1" ?
      true : false,
      lastUserAction = moment();

    const userContextStorage = StorageService.getLocalStorage("securityContext");
    if (userContextStorage !== "" && userContextStorage !== "undefined") {
      userContext = angular.fromJson(userContextStorage);
    }

    const service = {
      //loggedIn: false,
      isLogged: () => {
        return StorageService.getLocalStorage("access_token"); //potrei implementare una validazione del token dato l'expiry time
      },

      //FUNZIONI CHE INDICANO SE L'UTENTE e' UN CONSUMER SEMPLICE (M. Avanzi)
      isLoggedAsConsumer: () => {
        return StorageService.getLocalStorage("profileMode") === "0" ||
          StorageService.getLocalStorage("merchant-User") === "false"; //loggedAsConsumer;
      },
      setLoggedAsConsumer: (isConsumer) => {
        StorageService.setLocalStorage('profileMode', isConsumer ? 0 : 1);
      },

      haveTemporaryWallet: () => {
        let result = false;
        if (service.getUserContext() && service.getUserContext().associatedWallets) {
          const associatedWallets = service.getUserContext().associatedWallets;
          if (associatedWallets.length > 1) {
            for(var i=0;i<associatedWallets.length;i++) {
              if(associatedWallets[i].profile === "merchant") {
                result = associatedWallets[i].temporary === true || associatedWallets[i].temporary === "true";
                return result;
              }
            };
          } else {
            return result;
          }
        } else {
          return result;
        }
      },

      isMerchant: () => {
        const uc = StorageService.getLocalStorage("userContext");
        if (uc && uc !== "" && uc !== "undefined") {
          const
            ucParsed = JSON.parse(uc),
            merchantAssociatedWallet = _.filter(ucParsed.associatedWallets, function(o) {
              return (o.profile === "merchant" || o.profile === "hybrid") && o.temporary !== true && o.temporary !== "true";
            });
          return merchantAssociatedWallet.length > 0;
        } else {
          return false;
        }
      },

      setProfileDefaultinStorage: (value) => {
        profiloDefault = value;
        StorageService.setLocalStorage('profiloDefault', value);
      },
      getProfileDefault: () => {
        profiloDefault = StorageService.getLocalStorage("profiloDefault");
        return profiloDefault;
      },
      // FUNZIONE CHE RESTITUISCE il TIPO DI MERCHANT (M. Avanzi)
      getMerchantType: () => {
        if (!merchantType) {
          service.setMerchantType();
        }
        return merchantType;

      },

      setMerchantType: () => {
        if (service.getUserContext() && service.getUserContext().associatedWallets && !service.haveTemporaryWallet()) {
          const associatedWallets = service.getUserContext().associatedWallets;
          if (associatedWallets.length > 1) {
            merchantType = MerchantTypes.DOUBLE;
          } else {
            merchantType = associatedWallets[0].profile === "hybrid" ? MerchantTypes.EASY : MerchantTypes.BUSINESS;
          }
          return merchantType;
        } else {
          return;
        }
      },

      isMerchantTypeEasy: function() {
        return service.getMerchantType() === MerchantTypes.EASY;
      },

      /**
       *  @deprecated usare isMerchantTypeCorporate
       */
      isMerchantTypeBusiness: function() {
        return service.getMerchantType() === MerchantTypes.BUSINESS;
      },

      isMerchantTypeCorporate: function() {
        return service.getMerchantType() === MerchantTypes.BUSINESS;
      },

      isMerchantTypeDouble: function() {
        return service.getMerchantType() === MerchantTypes.DOUBLE;
      },

      //FUNZIONI PER GESTIRE LO SWITCH PER PROFILI IBRIDI MERCHANT/CONUSMER (M. Avanzi)

      //Funzione che ritorna un booleano che indica se il profilo necessita dello switch (M.A)
      isSwitchableProfile: () => {
        let res;
        if (service.isMerchant()) {
          res = service.getMerchantType() === MerchantTypes.DOUBLE;
        } else {
          res = false;
        }
        StorageService.setLocalStorage("switchableProfile", res);
        return res;
      },

      getModeProfile: () => {
        return switchModeProfile;
      },
      // quando avviene un cambiamento della modalità profilo (i.e. si attiva lo switch) viene
      //scatenato un evento "change Profile Mode" che ha come argomento il valore della nuova
      //modalità profilo:
      // 0 => modalità consumer, 1 =>modalità merchant (M.A)
      setConsumerProfile: () => {
        switchModeProfile = PROFILE_MODE.CONSUMER;
        service.setLoggedAsConsumer(true);
        StorageService.setLocalStorage("profileMode", switchModeProfile);
        //NewBackendService.cleanWalletId();
        service.setLoggedAsConsumer(true);
        //service.loggedIn = true;
        $rootScope.$broadcast("Change Profile Mode");
      },
      setMerchantProfile: () => {
        console.log("inside setMerchantProfile")
        switchModeProfile = PROFILE_MODE.MERCHANT;
        StorageService.setLocalStorage("profileMode", switchModeProfile);
        const merchantWalletId = service.getMerchantWalletID();
        /*if (merchantWalletId !== -1) {
          NewBackendService.setWalletId(merchantWalletId);
        }*/
        service.setLoggedAsConsumer(false);
        //service.loggedIn = true;
        $rootScope.$broadcast("Change Profile Mode");
      },
      setModeProfile: (mode) => {
        mode ? service.setMerchantProfile() : service.setConsumerProfile();
      },
      toggleProfileMode: () => {
        switchModeProfile === PROFILE_MODE.MERCHANT ? service.setConsumerProfile() : service.setMerchantProfile();
        Dispatcher.dispatch({
          actionType: "GLOBAL_CLEAN",
          data: undefined,
          state: "STORE_EMPTY"
        });
      },

      setLogged: (b) => {
        //service.loggedIn = b;
      },
      /**
       *
       */
      getUserContext: () => {
        userContext = StorageService.getLocalStorage("userContext");
        return userContext ? angular.fromJson(userContext) : "";
      },

      getBusinesses: () => {
        let businesses = StorageService.getLocalStorage("businesses");
        return businesses ? angular.fromJson(businesses) : null;
      },

      getCurrentWallet: () => {
        let b = StorageService.getLocalStorage("currentWallet");
        return b ? angular.fromJson(b) : null;
      },


      doReset: () => {
        service.resetProfileMode();
        userContext = undefined;
        merchantType = undefined;
        instrumentList = undefined;
        counterList = undefined;
        profiloDefault = StorageService.getLocalStorage("profiloDefault");
        switchModeProfile = StorageService.getLocalStorage("profileMode") === "1" ?
          true : false;

      },
      /**
       *
       */
      setUserContext: (uc) => {
        userContext = uc;
        StorageService.setLocalStorage("securityContext", angular.toJson(uc));
        service.setMerchantType();
        StorageService.setLocalStorage("merchant-User", true);
        if(uc.profile === 'BUSINESS') {
          StorageService.setLocalStorage("merchant-User", true);
          service.setMerchantProfile();
        }else if(uc.profile === 'CONSUMER') {
          StorageService.setLocalStorage("merchant-User", false);
          service.setConsumerProfile();
        }
        /*const associatedWallets = uc.associatedWallets;
        if (associatedWallets && !service.haveTemporaryWallet()) {
          StorageService.setLocalStorage("merchant-User", true);
          if (associatedWallets.length > 1) {
            merchantType = MerchantTypes.DOUBLE;
            // service.setMerchantProfile();
          } else {
            merchantType = associatedWallets[0].profile === "hybrid" ? MerchantTypes.EASY : MerchantTypes.BUSINESS;
            associatedWallets[0].profile === "hybrid" ? service.setConsumerProfile() : service.setMerchantProfile();
          }
          $rootScope.$broadcast("Merchant-profile-setted");
        } else {
          StorageService.setLocalStorage("merchant-User", false);
          service.setConsumerProfile();

        }*/
      },
      setInstrumentList: (il) => {
        instrumentList = il;
      },
      /**
       * @deprecated use NewUserInstrumentStore
       */
      getInstrumentList: () => {
        $log.warn("getInstrumentList deprecated: user NewUserInstrumentStore");
        if (instrumentList === undefined) {
          instrumentList = "";
        }
        return instrumentList;
      },
      setCounterList: (cl) => {
        counterList = cl;
      },
      getCounterList: () => {
        if (counterList === undefined) {
          counterList = "";
        }
        return counterList;
      },
      lastUserAction: undefined,
      getMerchantWalletID: () => {
        if (service.getUserContext()) {
          return  service.getUserContext().walletId;
        }else{
          return -1;
        }
      },
      /*getMerchantWalletID: () => {
        if (service.getUserContext() && service.getUserContext().associatedWallets) {
          const hybridProf = _.filter(service.getUserContext().associatedWallets, function(o) {
            return o.profile === "hybrid";
          });
          if (hybridProf.length > 0) { //handling hybrid profile. walletID is the same, but profile not
            return hybridProf[0].idWallet;
          }
          const merchantprof = _.filter(service.getUserContext().associatedWallets, function(o) {
            return o.profile === "merchant";
          });
          if (merchantprof.length > 0) {
            return merchantprof[0].idWallet;
          }
          $log.error("NewTokenService", "getMerchantWalletId", "No merchant profile found!");
          return -1;

        } else {
          $log.debug("NewTokenService", "getMerchantWalletId", "No associated wallets found!");
          return -1;
        }

      },*/
      resetProfileMode: () => {
        StorageService.clearLocalStorage("profileMode");
      },
      clearAllStorages: function() {
        StorageService.clearLocalStorage("access_token");
        StorageService.clearLocalStorage("refresh_token");
        StorageService.clearLocalStorage("securityContext");
        StorageService.clearLocalStorage("userContext");
        StorageService.clearLocalStorage("loggedFrom");
        StorageService.clearLocalStorage("merchant-User");
        StorageService.clearLocalStorage("switchableProfile");
        StorageService.clearLocalStorage("profileMode");
        StorageService.clearLocalStorage("profiloDefault");
        StorageService.clearLocalStorage("superAdmin");
        StorageService.clearLocalStorage("businesses");
        StorageService.clearLocalStorage("currentWallet");
      },

      checkLogout: () => {
        var timeoutTime = moment(lastUserAction).add(Environment.uiConfig.sessionTimeout, "m")
        if (service.isLogged() && moment().isAfter(timeoutTime)) {
          console.log("logout for timeout");
          $rootScope.$broadcast("event:auth-loginRequired");
        }
      },

      setLastUserAction(){
        lastUserAction = moment();
      }
    };

    return service;
}

export default TokenServiceFactory;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/token.factory.js
 **/